module.exports = __webpack_public_path__ + "img/ic_24_time_history.df15a64a.svg";